import request from '@/utils/request'

export function getCaptcha() {
  return request({ url: '/auth/captcha', method: 'get' })
}

export function login(data) {
  return request({ url: '/auth/login', method: 'post', data })
}

/**
 * 免验证码登录（测试专用）
 * - 用途：AI 自动化测试时直接调用获取 Token，无需处理图形验证码
 * - 测试账号：admin / 123456
 * - ⚠️ 上线前需关闭此接口
 */
export function loginWithoutCaptcha(data) {
  return request({ url: '/auth/loginWithoutCaptcha', method: 'post', data })
}

export function logout() {
  return request({ url: '/auth/logout', method: 'post' })
}

export function refreshToken(data) {
  return request({ url: '/auth/refresh', method: 'post', data })
}

export function getCurrentUser() {
  return request({ url: '/auth/currentUser', method: 'get' })
}

export function changePassword(data) {
  return request({ url: '/auth/password', method: 'put', data })
}
